import React, { Fragment, useCallback, useState } from 'react';
import CompetenceOrderContainer from './CompetenceOrderContainer';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_COMPETENCE_ORDERS } from 'constants/rightsCodes';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const { getElemByAreaKey } = props;
  const competenceOrderId = props.match.params.competenceOrderId && getInt(props.match.params.competenceOrderId);

  const onClickClose = useCallback(() => {
    historyContext.push(`/competenceOrders`);
  }, [historyContext]);

  const onChangeCompetenceOrderTitle = useCallback(competenceOrderTitle => {
    setTitle(competenceOrderTitle);
  }, []);

  const onRedirect = useCallback(
    competenceOrderId => {
      historyContext.push(`/competenceOrders/${competenceOrderId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_COMPETENCE_ORDERS}>
        <CompetenceOrderContainer
          competenceOrderId={competenceOrderId}
          onChangeCompetenceOrderTitle={onChangeCompetenceOrderTitle}
          onRedirect={onRedirect}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(withRouter(Route));
